/* eslint-disable jsx-a11y/anchor-is-valid */
import {FC} from 'react'
import {Licenses} from '../../core/_models'
import moment from 'moment'
import 'moment/locale/pt-br'

moment.locale('pt-br')

type Props = {
  Licenses: Licenses
}

const LicensesIssuerDate: FC<Props> = ({Licenses}) => (
  <div className='d-flex text-center justify-content-center'>
    <div className='d-flex flex-column'>
      <a href='#' className='text-gray-800 fw-semibold fs-9 mb-1'>
        {moment(Licenses.issue_date).format('L')}
      </a>
    </div>
  </div>
)

export {LicensesIssuerDate}
